import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { MDTFeedback, IconSet, MDTAnchor } from 'mdt-core-components';
import { MDTApp } from 'mdt-core-components/src/actions/bootAction';
import { sendEventTrackingData } from 'mdt-core-components/src/helpers/commonUtils';
import { get } from 'lodash';
import MDTNeedHelps from './mdt-needhelps';
import './right-float-menu.css';

class RightFloatElement extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isOpenMessage: false,
            isOpenNeedHelps: false,
        };
    }

    getSnapshotBeforeUpdate(prevProps) {
        if (
            prevProps.screenOverlay !== this.props.screenOverlay &&
            !!prevProps.screenOverlay &&
            !this.props.screenOverlay
        ) {
            return this.props.screenOverlay;
        }
        return null;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (snapshot !== null) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ isOpenMessage: false, isOpenNeedHelps: false });
        }
    }

    trackData = (eventCategory, eventLabel) => {
        const pageName = this.props.page;
        const eventParamObj = {
            eventCategory: eventCategory,
            eventAction: pageName,
            processActions: false,
            eventLabel: eventLabel,
        };
        sendEventTrackingData(eventParamObj);
    };

    toggleFeedback = (flag) => {
        this.setState({ isOpenMessage: !!flag, isOpenNeedHelps: false });
        this.props.showOverlay({ flag: !!flag, onClickClose: true });
        // tracking event for dataanalytics
        const eventLabel = flag ? 'surveyClicks' : 'cancel';
        this.trackData('takeSurvey', eventLabel);
    };

    toggleNeedHelps = (flag, isSubmit = false) => {
        this.setState({ isOpenMessage: false, isOpenNeedHelps: !!flag });
        this.props.showOverlay({ flag: !!flag, onClickClose: true });
        // tracking event for dataanalytics
        const eventLabel = flag ? 'needHelp' : 'cancel';
        ((flag && !isSubmit) || (!flag && !isSubmit)) && this.trackData('Help', eventLabel);
    };

    eventTrackForGoButton = () => {
        // tracking event for dataanalytics
        this.trackData('takeSurvey', 'go');
    };

    render() {
        const { t, getResourceAccess, rightElementTabConfig } = this.props;

        const feedBack = getResourceAccess('RightElementTab', 'Feature');
        return (
            <div>
                {!!feedBack && (
                    <div className='right-float-menu'>
                        {!!rightElementTabConfig.survey && (
                            <div className='feedback-float-menu'>
                                <MDTAnchor onClick={() => this.toggleFeedback(true)}>
                                    <IconSet name='Feedback' titleRequired={false} />
                                </MDTAnchor>
                                <span className='text-help body3'>{t('helpTextFeedback')}</span>
                            </div>
                        )}
                        {!!rightElementTabConfig.needHelp && (
                            <div className='contactus-float-menu'>
                                <MDTAnchor onClick={() => this.toggleNeedHelps(true)}>
                                    <IconSet name='Help' titleRequired={false} />
                                </MDTAnchor>
                                <span className='text-help body3'>{t('helpTextNeedhelps')}</span>
                            </div>
                        )}
                    </div>
                )}
                {feedBack && !!rightElementTabConfig.survey && (
                    <MDTFeedback
                        {...this.props}
                        isOpen={this.state.isOpenMessage}
                        toggle={this.toggleFeedback}
                        eventTrack={this.eventTrackForGoButton}
                    />
                )}
                {feedBack && !!rightElementTabConfig.needHelp && (
                    <MDTNeedHelps
                        {...this.props}
                        isOpen={this.state.isOpenNeedHelps}
                        toggle={this.toggleNeedHelps}
                    />
                )}
            </div>
        );
    }
}

RightFloatElement.propTypes = {
    message: PropTypes.string,
    hyperlinkButton: PropTypes.string,
    hyperlinkURL: PropTypes.string,
};

RightFloatElement.defaultProps = {
    message: 'feedbackBar.message',
    hyperlinkButton: 'feedbackBar.hyperlinkButton',
    hyperlinkURL: 'feedbackBar.hyperlinkURL',
};

function mapStateToProps(state) {
    return {
        userDetails: get(state, 'AccountDetails.user', {}),
        screenOverlay: state.bootDetails.screenOverlay,
        rightElementTabConfig: get(
            state,
            'formConfig.featureConfiguration.RightElementTab.configuration',
            { needHelp: false, survey: false }
        ),
        page: get(state, 'page', ''),
    };
}
function mapDispatchToProps(dispatch) {
    return {
        getResourceAccess: (resource, action) =>
            dispatch(MDTApp.getResourceAccess(resource, action)),
        showOverlay: (data) => dispatch(MDTApp.saveScreenOverlay(data)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(RightFloatElement));
